<template>
	<div class="icon-adder">
		<div class="icon-adder__img-box" v-if="src">
			<img class="icon-adder__img" :src="src" />
			<button
				class="btn-delete--only-icon icon-adder__cancel-button"
				@click="cancelImg"
			></button>
		</div>
		<label class="icon-adder__button" v-else>
			<input
				class="icon-adder__input"
				type="file"
				accept="image/*"
				ref="input"
				@change="fileChange"
			/>
		</label>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import { getS3Url, uploadS3 } from '@/util.js';

	export default {
		name: 'IconAdder',
		props: {
			useSizeCheck: {
				type: Boolean,
				default: true,
			},
			useCustomCancel: {
				type: Boolean,
				default: false,
			},
			useViewOrigin: {
				type: Boolean,
				default: false,
			},
			width: {
				type: Number,
				default: 36 * 3,
			},
			height: {
				type: Number,
				default: 36 * 3,
			},
		},
		data() {
			return {
				src: '',
				extension: '',
				image: null,
			};
		},
		computed: {
			...mapState({
				IMAGE_STORAGE_PATH: state => state.env.IMAGE_STORAGE_PATH,
			}),
		},
		methods: {
			imageOnloadCb({ target }) {
				if (
					this.useSizeCheck &&
					(this.width !== target.naturalWidth ||
						this.height !== target.naturalHeight)
				) {
					alert(
						`이미지 사이즈를 맞춰주세요. 가로: ${this.width}px, 세로: ${this.height}px`
					);
					return;
				}
				this.src = target.src;
				this.$emit('change', target.src);
			},
			readerOnloadCb({ target }) {
				const imgObj = new Image();
				imgObj.onload = this.imageOnloadCb;
				imgObj.src = target.result;
			},
			fileChange({ target }) {
				const image = target.files[0];
				target.value = null;
				if (!image) {
					return false;
				}
				const reader = new FileReader();
				reader.onload = this.readerOnloadCb;
				reader.readAsDataURL(image);
				this.extension = image.type.split('/').pop();
				this.image = image;
			},
			cancelImg() {
				if (this.useCustomCancel) {
					this.$emit('cancel');
					return;
				}
				this.src = '';
				this.$emit('change', '');
			},
			async upload() {
				const { data } = await getS3Url(this.extension, 'collection');
				await uploadS3(data, this.image);
				return `${this.IMAGE_STORAGE_PATH}/${data.fields.key}`;
			},
		},
	};
</script>
<style lang="scss">
	DIV.icon-adder {
		width: 100px;
		height: 100px;

		.icon-adder__button {
			cursor: pointer;
			position: relative;
			display: block;
			width: 100%;
			height: 100%;
			border: solid 1px #dfe6ee;

			&:before,
			&:after {
				content: '';
				position: absolute;
				display: block;
				width: 2px;
				height: 18px;
				left: 0;
				right: 0;
				top: 0;
				bottom: 0;
				margin: auto;
				background: #b0bac5;
			}

			&:after {
				transform: rotate(90deg);
			}

			&:hover {
				border-color: #b0bac5;
			}
		}

		.icon-adder__input {
			display: none;
		}

		.icon-adder__img-box,
		.icon-adder__img {
			display: block;
			width: 100%;
			height: 100%;
		}

		.icon-adder__img-box {
			position: relative;
		}

		.icon-adder__cancel-button {
			position: absolute;
			top: 0;
			right: 0;
			width: 20px;
			height: 20px;
			padding: 0;
			border-radius: 0;
		}
	}
</style>
